import { FunctionComponent } from "react"
import Image from "next/image"
import {
  demoFormReward,
  demoFormRewardMweb,
} from "DataMapper/IeltsSection/Ielts"
import useDevice from "hooks/useDevice"

const DemoFormFillOffer: FunctionComponent = () => {
  const { isMobile } = useDevice()
  return (
    <div className="bg-white/[.8] rounded-lg p-4 md:py-6">
      {isMobile && (
        <h3 className="text-[#1C1C1C] text-[14px] font-bold mb-3">
          What to expect in session:
        </h3>
      )}
      <div className="md:flex gap-x-10">
        {(isMobile ? demoFormRewardMweb : demoFormReward).map((item, index) => (
          <div
            key={item.id}
            className={`flex items-center py-2 md:p-3 ${
              index !== 0 ? "border-l border-[#E3E2FF]" : ""
            }`}
          >
            <Image
              src={item.image}
              alt={"Ielts rewards"}
              width={30}
              height={30}
            />
            <div className="pl-2 text-[#424242] text-[12px] md:text-[14px]">
              {item.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
export default DemoFormFillOffer
